import { Form } from "react-bootstrap";
import { useForm } from "react-hook-form";
import { useContext } from "react";
import { getLink, sendCallToAPI } from "../../../common/generic_functions";
import { links } from "../links";
import { FormLoginWrapper, FormWrapper } from "./wrappers";
import { AlertContext } from "../login";
import "../login.sass";

export const handleKeyDownTab = (event, toFocusedElement) => {
  if (event.key === "Tab" && toFocusedElement) {
    document.getElementById(toFocusedElement).focus();
    event.preventDefault(); // Prevent default tab behavior
  }
};

export const ForgotPassword = ({ handleBackClick, LoginContext }) => {
  const methods = useForm();
  const { setMessageProps, setLoading } = useContext(LoginContext);
  const { enableAlert } = useContext(AlertContext);

  const onSubmit = (data) => requestResetPassword(data);

  const requestResetPassword = async (formdata) => {
    const link = getLink("", links, "reset_password_request");
    let result;
    let messageProps = {};
    try {
      result = await sendCallToAPI(link, "notoken", formdata, "POST");

      if (result?.message && result?.status === "danger") {
        throw new Error({ text: result.message, messageType: result.status });
      } else if (result?.message && result?.status) {
        messageProps = { type: result.status, text: "Reset link is send over the email" };
        handleBackClick();
      }
    } catch (e) {
      messageProps = e.messageType ? e : { type: "danger", text: "Sorry, an unexpected error has occurred!" };
    } finally {
      enableAlert(messageProps);
      setLoading(false);
    }
  };

  return (
    <FormWrapper onSubmit={onSubmit} methods={methods} handleBackClick={handleBackClick} heading={"Reset your password"}>
      <Form.Control
        id="req-first"
        onKeyDown={(e) => handleKeyDownTab(e, "req-first")}
        type="email"
        placeholder="Enter your email address"
        required
        {...methods.register("emailAddress")}
        className="code-input"
      />
    </FormWrapper>
  );
};

export const SecCodeVerification = ({ onSubmit, methods, handleBackClick }) => {
  return (
    <FormWrapper onSubmit={onSubmit} methods={methods} handleBackClick={handleBackClick} heading={"Authenticate with security code"}>
      <Form.Control
        id="sec-code-first"
        onKeyDown={(e) => handleKeyDownTab(e, "sec-code-first")}
        placeholder="Enter the security code here"
        required
        {...methods.register("code")}
        className="code-input"
      />
    </FormWrapper>
  );
};

export const LoginCreds = ({ onSubmit, methods, formStage, LoginContext, forgot, forgetPasswordFormStart, setIsHovering }) => {
  return (
    <FormLoginWrapper
      onSubmit={onSubmit}
      LoginContext={LoginContext}
      forgot={forgot}
      forgetPasswordFormStart={forgetPasswordFormStart}
      methods={methods}
      formStage={formStage}
      text={"Login with your account data"}
    >
      <div>
        <Form.Control
          tabIndex={"1"}
          id="login-first"
          onFocus={() => setIsHovering(true)}
          style={{ borderRadius: "50px", minWidth: "350px", minHeight: "50px", padding: "5px 15px", border: "1px solid #000" }}
          type="text"
          placeholder="Email"
          required
          {...methods.register("username")}
        />
        <div style={{ paddingBottom: "5px" }}></div>
        <Form.Control
          tabIndex={"2"}
          onKeyDown={(e) => handleKeyDownTab(e, "login-first")}
          onFocus={() => setIsHovering(true)}
          style={{ borderRadius: "50px", minWidth: "350px", minHeight: "50px", padding: "5px 15px", border: "1px solid #000" }}
          type="password"
          placeholder="Password"
          required
          {...methods.register("password")}
        />
      </div>
    </FormLoginWrapper>
  );
};
